/*******************************************************************************
CHECK FOR MATCH
Checks if an item matches the current filter.
*******************************************************************************/

export default function checkForMatch($item, filterSettings, tabSettings) {

    // This is done purely for code readabilty
    const subset = filterSettings.subset;
    const { dataToMatch, secDataToMatch, mainExclude, matchType, secSubsetOperator, secSubset, secExclude, secMatchType } = tabSettings;

    // If the 'All' option (*) is passed in, then everything matches
    if (dataToMatch[0] === '*') { return true; }

    let $elementToSearch = $item;

    // If there's a subset (and it's not targeting a data attribute) then use that when the searching the item
    if (subset && subset[0] !== '[') { $elementToSearch = $item.find(subset); }

    // This is where we'll store the value to match against
    let itemValue = '';

    // If the subset starts with '[' then you know it's targeting a data attribute instead of a normal selector
    // This gets set in the subset data attribute in the HMTL like this "[attrname]"
    if (subset[0] === '[') {
        const subsetTargetAttribute = subset.replace('[', '').replace(']', '');
        itemValue = $.trim($item.data(subsetTargetAttribute)) || '';
    }
    else {

        // Find the value of the text to match against
        itemValue = $.trim($elementToSearch.text()) || '';

        // Find the value from an input
        if ($elementToSearch.is(':input')) { itemValue = $.trim($elementToSearch.val()); }

        // Find the value from a radio button
        if ($elementToSearch.next('input').is('[type="radio"]')) { itemValue = $.trim($elementToSearch.next('input').val()); }
    }

    // Check if the item matches the main filter
    let mainFilterMatches = false;

    // If the data needs to be an exact match
    if (matchType === 'exact') {
        mainFilterMatches = (mainExclude) ? $.inArray(itemValue, dataToMatch) === -1 : $.inArray(itemValue, dataToMatch) > -1;
    }

    // If the data only needs to be contained in the value
    if (matchType === 'contains') {
        dataToMatch.forEach((valToMatch) => {
            const valMatched = (mainExclude) ? !itemValue.includes(valToMatch) : itemValue.includes(valToMatch);
            if (valMatched) { mainFilterMatches = true; }
        });
    }

    // Defaults for when there is no secondary filter in use
    let secSubsetMatches = (secSubsetOperator === 'AND');

    // If we're using a secondary filter, this handles that matching
    if (secSubset) {
        secSubsetMatches = false;

        // Use the secondary filter when the searching the item
        const $secElemToSearch = $item.find(secSubset);

        // This is where we'll store the value to match against
        let secItemValue = '';

        // If the secondary subset starts with '[' then you know it's targeting a data attribute instead of a normal selector
        // This gets set in the secondary subset data attribute in the HMTL like this "[attrname]"
        if (secSubset[0] === '[') {
            const secSubsetTargetAttribute = secSubset.replace('[', '').replace(']', '');
            secItemValue = $.trim($item.data(secSubsetTargetAttribute)) || '';
        }
        else {

            // Find the value of the text to match against
            secItemValue = $.trim($secElemToSearch.text()) || '';

            // Find the value from an input
            if ($secElemToSearch.is(':input')) { secItemValue = $.trim($secElemToSearch.val()); }

            // Find the value from a radio button
            if ($secElemToSearch.next('input').is('[type="radio"]')) { secItemValue = $.trim($secElemToSearch.next('input').val()); }
        }

        // If the data needs to be an exact match
        if (secMatchType === 'exact') {
            secSubsetMatches = (secExclude) ? $.inArray(secItemValue, secDataToMatch) === -1 : $.inArray(secItemValue, secDataToMatch) > -1;
        }

        // If the data only needs to be contained in the value
        if (secMatchType === 'contains') {
            secDataToMatch.forEach((valToMatch) => {
                const valMatched = (secExclude) ? !secItemValue.includes(valToMatch) : secItemValue.includes(valToMatch);
                if (valMatched) { secSubsetMatches = true; }
            });
        }
    }

    // These are the two options for the secondary operator (defaults to AND)
    const filterOptions = {
        AND: () => mainFilterMatches && secSubsetMatches,
        OR : () => mainFilterMatches || secSubsetMatches,
    };

    // See if the item matches the filter(s) using AND or OR (depending on what the secondary operator is)
    const filterMatches = filterOptions[secSubsetOperator]();

    // Returns true if the item matched the filter, false if it doesn't
    return filterMatches;
}
